import { EventResponse } from '@goldcast/api/backend';

export function transformServerEvents(events: EventResponse[]) {
  const transformedEvents = {};
  events.forEach(event => {
    transformedEvents[event.id] = event;
  });
  return transformedEvents;
}
